import { Component, OnInit } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ClientService } from '../services/client.service';
import { Router, RouterModule } from '@angular/router';
import { APIUrl } from '../constant/api-call';
import * as _ from 'underscore';
import { PrimeNgModule } from '../shared/prime-ng.module';
import { CommonModule } from '@angular/common';
import { SelectModule } from 'primeng/select';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProjectService } from '../services/project.service';

@Component({
  selector: 'app-user-creation',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PrimeNgModule,
    RouterModule,
    SelectModule,
    MultiSelectModule,
    ToggleSwitchModule,
    ButtonModule,
    DialogModule,
  ],
  templateUrl: './user-creation.component.html',
  styleUrls: ['./user-creation.component.css']
})
export class UserCreationComponent implements OnInit {
  public userForm: FormGroup;

  public commonDataObject = {
    APIObj: APIUrl,
    selectedUser: null,
    project_id: [] as any[],
    projects: [] as any[],
    issuccessAlert: false,
    iserrorAlert: false,
    apiMeassge: '',
    displayDialog: false,
    deleteDialog: false
  }
  public defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1
  };
  public columnDefs: ColDef[] = [
    {
      headerName: 'Sr. No.',
      flex: 0.5,
      valueGetter: (params: any) => params.node?.rowIndex ? params.node.rowIndex + 1 + '.' : 1,
    },
    {
      headerName: 'First Name',
      field: 'first_name',
      flex: 1,
      sortable: true,
      filter: true
    },
    {
      headerName: 'Last Name',
      field: 'last_name',
      flex: 1,
      sortable: true,
      filter: true
    },
    {
      headerName: 'Email',
      field: 'email_address',
      flex: 2,
      sortable: true,
      filter: true
    },
    {
      headerName: 'Contact',
      field: 'contact_number',
      flex: 1,
      sortable: true,
      filter: true
    },
    {
      headerName: 'User Category',
      field: 'user_category_name',
      flex: 1.5,
      sortable: true,
      filter: true
    },
    {
      headerName: 'Project',
      field: 'project_name',
      flex: 2,
      sortable: true,
      filter: true
    },
    {
      headerName: 'Status',
      flex: 1,
      field: 'is_active',
      sortable: true,
      filter: true,
      valueFormatter: (params: any) => {
        return params.value ? 'Active' : 'In Active';
      }
    },
    {
      headerName: 'Actions',
      flex: 1,
      cellRenderer: () => `
        <span>
          <i class="fa fa-edit text-primary me-2 edit-btn" title="Edit"></i>
          <i class="fa fa-trash text-danger delete-btn" title="Delete"></i>
          </span>`,
      onCellClicked: (params: any) => {
        const target = params?.event?.target as HTMLElement;
        if (target.classList.contains('edit-btn')) {
          this.editUser(params.data);
        }
        if (target.classList.contains('delete-btn')) {
          this.commonDataObject.deleteDialog = true;
          this.commonDataObject.selectedUser = params.data;
        }
      }
    }
  ];
  public gridApi: any;
  public userCategory: any;
  public userCreationList:any[] = [];
  public loading = false;

  constructor(
    private fb: FormBuilder,
    private clientService: ClientService,
    public projectService: ProjectService) {
    this.userForm = this.fb.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      user_code: [''],
      email_address: ['', Validators.required],
      password: ['', Validators.required],
      contact_number: ['', Validators.required],
      project: ['', Validators.required],
      user_category: ['', Validators.required],
      is_active: [true]
    });
  }

  ngOnInit(): void {
    this.projectService.getMasterData();
    setTimeout(()=>{
      const userRole = sessionStorage.getItem('user_category_code');
      const userCode = sessionStorage.getItem('user_code');
      if(userRole === 'ADMIN'){
        this.userCategory = this.projectService.getUserCatData().filter(e=>{
         return e?.user_category_key !== "SUPER_ADMIN";
        });
        this.userCreationList = this.projectService.getUserData().filter(e=>{
          return e?.user_category_key === "USER" || (e?.user_category_key === "ADMIN" && e?.user_code == userCode);
        });
      } else {
        this.userCategory = this.projectService.getUserCatData();
        this.userCreationList = this.projectService.getUserData();
      }
      if(this.userCreationList?.length === 0){
        this.loading = true;
      }
    },500);
  }

  onGridReady(params: any) {
    this.gridApi = params.api;

    window.addEventListener('resize', () => {
      this.gridApi.sizeColumnsToFit();
    });
  }

  onFirstDataRendered(params: any) {
    params.api.sizeColumnsToFit();
  }

  addUser() {
    this.commonDataObject.displayDialog = true;
    this.userForm.reset();
  }

  cancel() {
    this.commonDataObject.displayDialog = false;
    this.userForm.reset();
  }

  editUser(rowData: any) {
    const projects = rowData?.project_id?.split(',').map((id: string) => id.trim());
    this.commonDataObject.displayDialog = true;
    this.userForm.patchValue({
      first_name: rowData?.first_name ?? '',
      last_name: rowData?.last_name ?? '',
      email_address: rowData?.email_address ?? '',
      contact_number: rowData?.contact_number ?? '',
      project: this.projectService.getProjectMaster()?.filter(
        (p: any) => projects.includes(String(p.project_id))),
      user_code: rowData?.user_code ?? null,
      user_category: this.projectService.getUserCatData()?.find((config: any) => config.user_category_id == rowData?.user_category_id) ?? null,
      is_active: rowData?.is_active ?? false
    });
    this.userForm.get('password')?.clearValidators();
    this.userForm.get('password')?.updateValueAndValidity();
  }

  saveUserData(arg?: any) {
    this.projectService.loading.set(true);
    const userData = arg ? this.commonDataObject.selectedUser : this.userForm.value;
    let payload = {
      "first_name": userData?.first_name ?? '',
      "last_name": userData?.last_name ?? '',
      "email_address": userData?.email_address ?? '',
      "contact_number": userData?.contact_number ?? '',
      "password": userData?.password ?? '',
      "is_active": userData?.is_active ?? false,
      "is_delete": arg ? true : false,
      "user_category_id": arg ? userData?.user_category_id : userData?.user_category?.user_category_id ?? null,
      "project_id": arg ? userData?.project_id : _.pluck(userData['project'], 'project_id').toString() ?? null,
      "user_code": userData?.user_code ?? null
    }
    this.clientService.postAPI(this.commonDataObject.APIObj.USER_REGISTER, payload).subscribe((res: any) => {
      if (res && res.code == 'CSR_MS_OK_200') {
        this.commonDataObject.displayDialog = false;
        this.commonDataObject.deleteDialog = false;
        this.userForm.reset();
        this.commonDataObject.apiMeassge = res.message;
        this.commonDataObject.issuccessAlert = true;
        this.ngOnInit();
      }
      else {
        this.commonDataObject.apiMeassge = res.message;
        this.commonDataObject.iserrorAlert = true;
      }
      setTimeout(() => {
        this.projectService.loading.set(false);
        this.commonDataObject.issuccessAlert = false;
        this.commonDataObject.iserrorAlert = false;
      }, 1000);
    },
      (error) => {
        this.commonDataObject.iserrorAlert = true;
        this.commonDataObject.apiMeassge = error.error.message;
        setTimeout(() => {
          this.projectService.loading.set(false);
          this.commonDataObject.issuccessAlert = false;
          this.commonDataObject.iserrorAlert = false;
        }, 1000);
      });
  }
}
